import { render, staticRenderFns } from "./AboutHowIsDifferent.vue?vue&type=template&id=e87538b2&"
import script from "./AboutHowIsDifferent.vue?vue&type=script&lang=js&"
export * from "./AboutHowIsDifferent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports